import React from 'react'
import { FormControl, FormLabel, Select, MenuItem, FormHelperText } from '@material-ui/core'
import { states } from '../../../data/citiesAndStates'
import { makeStyles } from '@material-ui/core/styles'
import { useForm } from '../../../providers'

const useStyles = makeStyles((theme) => {
    return {
        label: {
            marginBottom: '0.5rem',
        },
        btn: {
            width: 'max-content',
            textTransform: 'none',
            marginBottom: '2rem',
        },
        flex: {
            display: 'flex',
            justifyItems: 'space-between',
            gap: theme.spacing(2),
        },

        fullWidth: {
            width: '100%',
        },
    }
})

export const StateSelector = () => {
    const classes = useStyles()
    const { dispatch, formState, error } = useForm()

    return (
        <FormControl className={classes.fullWidth} error={error?.state ? true : false}>
            <FormLabel className={classes.label}>{'State'}</FormLabel>
            <Select
                labelId="state"
                variant="outlined"
                id="state"
                value={formState.state}
                onChange={(e) =>
                    dispatch({
                        type: 'STATE',
                        payload: { type: 'state', value: e.target.value },
                    })
                }
                className={classes.fullWidth}
            >
                {states.map((state) => (
                    <MenuItem key={state.name} value={state.name}>
                        {state.name}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText> {error?.state?.error || ''} </FormHelperText>
        </FormControl>
    )
}
